import { styled as t } from "styled-components";
import { BodyHeavy as e } from "../../styles/typography/index.js";
import { MediaQuery as i, HEADER_HEIGHT as o, MODAL_OVERLAY as n, ZIndex as p } from "../../styles/variables.js";
const a = t.div`
  width: 100%;
  height: 100%;

  @media ${i.SCREEN_MD_UP} {
    position: relative;
  }
`, s = t.div`
  display: none;

  @media ${i.SCREEN_MD_UP} {
    top: ${o}px;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    width: 100vw;
    height: 100vh;
    min-height: 100%;
    min-width: 100%;
    background: ${n};
    z-index: ${p.HEADER_CONTAINER - 1};
  }
`;
t.ul`
  list-style-type: none;
  padding: 0;
  margin-top: 8px;

  &:first-of-type {
    margin-top: unset;
  }
`;
t.p`
  ${e}
  margin-bottom: 16px;

  &:first-of-type {
    margin-top: unset;
  }
`;
export {
  a as Container,
  s as Overlay
};
